import type { ScanJob, ScanJobInput } from '@detect/shared';
import { api, withTenant, type PaginatedResult } from './api';
import type { WithId } from './types';

export const scanJobService = {
  list: (
    tenantId: string,
    params: { limit?: number; startAfter?: string } = {}
  ): Promise<PaginatedResult<WithId<ScanJob>>> =>
    api.getPaginated<WithId<ScanJob>>(
      withTenant('/discovery/scan-jobs', tenantId, params)
    ),

  get: (tenantId: string, id: string): Promise<WithId<ScanJob>> =>
    api.get<WithId<ScanJob>>(withTenant(`/discovery/scan-jobs/${id}`, tenantId)),

  create: (tenantId: string, input: ScanJobInput): Promise<WithId<ScanJob>> =>
    api.post<WithId<ScanJob>>(withTenant('/discovery/scan-jobs', tenantId), input),

  update: (
    tenantId: string,
    id: string,
    patch: Record<string, unknown>
  ): Promise<WithId<ScanJob>> =>
    api.patch<WithId<ScanJob>>(
      withTenant(`/discovery/scan-jobs/${id}`, tenantId),
      patch
    ),

  run: (tenantId: string, id: string): Promise<{ runId?: string }> =>
    api.post<{ runId?: string }>(
      withTenant(`/discovery/scan-jobs/${id}/run`, tenantId)
    ),

  remove: (tenantId: string, id: string): Promise<void> =>
    api.delete(withTenant(`/discovery/scan-jobs/${id}`, tenantId)),
};
